import Missing from "../../Missing";
import Header from "../../../components/common/Header";
import TiptapView from "../../../components/common/input-layout/tiptap/TiptapView";
import {useEffect, useState} from "react";
import {getCADInfos} from "../../../api/admin/cadReq";
import {useNavigate, useParams} from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import FormCAD from "../../../forms/admin/FormCAD";
import Icon from "../../../components/common/Icon";

export default function ViewCADInfos() {
    const { id } = useParams();
    const { auth } = useAuth();
    const token = auth.token;
    const [ cadInfos, setCadInfos ] = useState();
    const [ showModal, setShowModal ] = useState(false);
    const [ forceHideModal, setForceHideModal ] = useState(false);
    const navigate = useNavigate();

    const apiCadInfos = async () => {
        const response = await getCADInfos(token, id);
        setCadInfos(response);
    }

    const handleCADForm = () => {
        setShowModal(true);
    }

    useEffect(() => {
        apiCadInfos();
    }, [ id ]);

    return (
        <main>
            {(cadInfos?.error && id != 0) &&
                <Missing/>
            }
            {(!cadInfos?.error || id == 0) &&
                <><Header parent="Courriers après décès"
                          location={(id !== 0)
                              ? "Modification d'un courrier "
                              : "Ajout d'un document "}
                          locationComp={`${cadInfos && cadInfos?.name ? cadInfos.name : ""}`}
                          slug="/admin/documents/courriers"
                />
                    {((id == 0 && forceHideModal == false) || showModal) &&
                        <div className="modal courrier-infos">
                            <FormCAD cadInfos={cadInfos} apiCadInfos={apiCadInfos} setShowModal={setShowModal} legend={id == 0 ? `Ajout d'un courrier` : `Modification d'un courrier`}/>
                        </div>
                    }
                    <form>
                        <fieldset>
                            <Icon span="Informations d'un courrier" source="fa-solid fa-file-lines"/>
                            <div className="form-input">
                                <label>Numéro du courrier</label>
                                <span>{cadInfos?.number}</span>
                            </div>
                            <div className="form-input">
                                <label>Nom du courrier</label>
                                <span>{cadInfos?.name}</span>
                            </div>
                            <div className="form-input">
                                <label>Description</label>
                                <span><TiptapView content={cadInfos?.description}/></span>
                            </div>
                            <div className="form-input html-textarea view">
                                <label>Références complémentaires</label>
                                <TiptapView content={cadInfos?.additionalReferences}/>
                            </div>
                            <div className="form-input html-textarea view">
                                <label>Sous références</label>
                                <TiptapView content={cadInfos?.afterReferences}/>
                            </div>
                            <div className="form-input html-textarea view">
                                <label>Contenu</label>
                                <TiptapView content={cadInfos?.content}/>
                            </div>
                            <div className="form-input html-textarea view">
                                <label>Pièces complémentaires</label>
                                <TiptapView content={cadInfos?.additionalAttachments}/>
                            </div>
                        </fieldset>
                        <div className="buttons-container">
                            <button type="button" className={"red-button"} onClick={() => setShowModal(true)}><i className="fa fa-pen-to-square"/><span>Modifier les informations</span></button>
                        </div>
                    </form>
                    <button onClick={() => navigate(-1)}><i className="fa fa-arrow-left"/><span>Retour</span></button>
                </>
            }
        </main>
    )
}